// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"a8b646c9","366":"dede4773","395":"0fc6512f","453":"7166d416","564":"605731fe","600":"3bac1205","771":"00c8ab25","969":"3f354a01"}[chunkId] + ".chunk.js";
};